import Vue from 'vue'
import Vuex from 'vuex'
import moment from 'moment'
import decode from 'jwt-decode'
import router from '../router'
import createPersistedState from 'vuex-persistedstate'
import * as Cookies from 'js-cookie'
import SecureLS from 'secure-ls'
var ls = new SecureLS({
  encodingType: 'rc4',
  isCompression: false,
  encryptionSecret: '$$w0rd@123',
})
import axios from 'axios'
//import { setupMaster } from "cluster";

Vue.use(Vuex)

const vuexLocal = new createPersistedState({
  //storage: window.sessionStorage
  //storage: window.localStorage
  storage: {
    getItem: (key) => ls.get(key),
    setItem: (key, value) => ls.set(key, value),
    removeItem: (key) => ls.remove(key),
    // getItem: key => Cookies.get(key),
    // setItem: (key, value) =>
    //   Cookies.set(key, value, { expires: 2, secure: false }),
    // removeItem: key => Cookies.remove(key)
  },
})

export default new Vuex.Store({
  state: {
    token: null,
    user: null,
    shops: null,
    products: null,
    category: null,
    categoryOnly: [],
    editShop: null,
    alertFlat: false,
    alertMsj: null,
    cateShop: [],
  },
  getters: {
    getAlertFlat: (state) => {
      return state.alertFlat
    },
    getAlertMsj: (state) => {
      return state.alertMsj
    },
    isLogin: (state) => {
      return state.user
    },
    userId: (state) => {
      return state.user._id
    },
    getShops: (state) => {
      return state.shops
    },
    getProducts: (state) => {
      return state.products
    },
    getEditShop: (state) => {
      return state.editShop
    },
    getCateShop: (state) => {
      return state.cateShop
    },
    getCategoryList: (state) => {
      return state.category
    },

    getShopByUser: (state) => (id) => {
      return state.articles.find((article) => article._id === id)
    },
    getShopById: (state) => (id) => {
      return state.articles.find((article) => article._id === id)
    },
  },
  mutations: {
    setAlert(state, obj) {
      state.alertFlat = obj.flat
      state.alertMsj = obj.msj
    },
    setToken(state, token) {
      state.token = token
    },
    setUser(state, user) {
      state.user = user
    },
    setShops(state, shops) {
      state.shops = shops
    },
    setProducts(state, products) {
      state.products = products
    },
    setCategoryOnly(state, category) {
      state.categoryOnly = category
    },
    setCategory(state, category) {
      state.category = category
    },
    setCateShop(state, cate) {
      state.cateShop = cate
    },
  },
  actions: {
    alertGeneral({ commit }, obj) {
      //console.log('el mensaje es', obj)
      commit('setAlert', obj)
    },
    saveToken({ commit }, token) {
      commit('setToken', token)
      commit('setUser', decode(token))
      localStorage.setItem('token', token)
    },
    autoLogin({ commit }) {
      const token = localStorage.getItem('token')
      if (!token) {
        //commit("setToken", token);
        //commit("setUser", decode(token));
        return
      }
      commit('setToken', token)
      commit('setUser', decode(token))
      //if (router.path !== { name: "home" }) router.push({ name: "home" })
      //router.push({ name: "home" });
      //router.push({ path: '/' })
    },
    signOut({ commit }) {
      commit('setToken', null)
      commit('setUser', null)
      localStorage.removeItem('token')
      router.push({
        path: '/signin',
      })

      //router.push({ name: "signin" });
    },

    async listCategory({ commit }) {
      try {
        let res = await axios.get(`category/list/${this.state.user._id}`)
        let { data } = res.data
        // actualice la lista y mande a producto listado
        //console.log(res.status)
        commit('setCategory', res.data)
      } catch (error) {
        //console.error(error)
        commit('setCategory', {
          name: error,
        })
      }
    },
    async listCategoryOnlyShop({ param, commit }) {
      try {
        let res = await axios.get(`category/query/catshop/${param}`)
        let { data } = res.data
        // actualice la lista y mande a producto listado
        //console.log(res.status)
        commit('setCategoryOnly', res.data)
      } catch (error) {
        //console.error(error)
        commit('setCategoryOnly', {
          name: error,
        })
      }
    },
    categoryShop({ commit }) {
      let category = [
        'Casa y Jardín',
        'Comidas y bebidas',
        'Entretenimiento',
        'Ropa y accesorios',
        'Electrónica',
        'Salud y Belleza',
        'Deportes',
        'Vehiculos',
        'Pasatiempos',
        'Otros',
      ]
      commit('setCateShop', category)
    },
    async newCategory({ dispatch, commit }, formData) {
      try {
        let res = await axios.post('category/add', formData)
        let { data } = res.data
        await dispatch('listCategory')
        // actualice la lista y mande a producto listado
        //console.log(res.status, res.data)
      } catch (error) {
        //console.error(error)
      }
    },
    async updateCategory({ dispatch, commit }, formData) {
      try {
        let res = await axios.put('category/update', formData)
        let { data } = res.data
        await dispatch('listCategory')
        // actualice la lista y mande a producto listado
        //console.log(res.status, res.data)
      } catch (error) {
        //console.error(error)
      }
    },
    async deleteCategory({ dispatch, commit }, idObjet) {
      try {
        //console.log('--delete', idObjet)
        let res = await axios.delete('category/remove', {
          data: idObjet,
        })
        let { data } = res.data
        // actualice la lista y mande a producto listado
        await dispatch('listCategory')
        //console.log(res.status, res.data)
      } catch (error) {
        //console.error(error)
        //onsole.log(res.status, res.data)
      }
    },
    async newShop({ dispatch, commit }, formData) {
      try {
        let res = await axios.post('shop/add', formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        })
        let { data } = res.data
        await dispatch('listShops')
        // actualice la lista y mande a producto listado
        //console.log(res.status, res.data)
      } catch (error) {
        //console.error(error)
      }
    },
    async listShops({ commit }) {
      try {
        let res = await axios.get(`shop/list/${this.state.user._id}`)
        let { data } = res.data
        // actualice la lista y mande a producto listado
        //console.log(res.status)
        commit('setShops', res.data)
      } catch (error) {
        //console.error(error)
        commit('setShops', {
          name: error,
        })
      }
    },
    async updateShop({ dispatch, commit }, formData) {
      try {
        let res = await axios.put('shop/update', formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        })
        let { data } = res.data
        // actualice la lista y mande a producto listado
        await dispatch('listShops')
        //console.log(res.status, res.data)
      } catch (error) {
        //console.error(error)
        //onsole.log(res.status, res.data)
      }
    },
    async deleteShop({ dispatch, commit }, idObjet) {
      try {
        //console.log('--delete', idObjet)
        let res = await axios.delete('shop/remove', {
          data: idObjet,
        })
        let { data } = res.data
        // actualice la lista y mande a producto listado
        await dispatch('listShops')
        //console.log(res.status, res.data)
      } catch (error) {
        //console.error(error)
        //onsole.log(res.status, res.data)
      }
    },
    async listProducts({ commit }) {
      try {
        let res = await axios.get(`product/list/${this.state.user._id}`)
        let { data } = res.data
        // actualice la lista y mande a producto listado
        //console.log(res.status)
        commit('setProducts', res.data)
      } catch (error) {
        //console.error(error)
        commit('setProducts', {
          name: error,
        })
      }
    },
    async newProduct({ dispatch, commit }, formData) {
      try {
        let res = await axios.post('product/add', formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        })
        let { data } = res.data
        await dispatch('listProducts')
        // actualice la lista y mande a producto listado
        //console.log(res.status)
      } catch (error) {
        //console.error(error)
      }
    },
    async updateProduct({ dispatch, commit }, formData) {
      try {
        let res = await axios.put('product/update', formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        })
        let { data } = res.data
        // actualice la lista y mande a producto listado
        await dispatch('listProducts')
        //console.log(res.status, res.data)
      } catch (error) {
        //console.error(error)
        //onsole.log(res.status, res.data)
      }
    },
    async deleteProduct({ dispatch, commit }, idObjet) {
      try {
        //console.log('--delete', idObjet)
        let res = await axios.delete('product/remove', {
          data: idObjet,
        })
        let { data } = res.data
        // actualice la lista y mande a producto listado
        await dispatch('listProducts')
        //console.log(res.status, res.data)
      } catch (error) {
        //console.error(error)
        //onsole.log(res.status, res.data)
      }
    },
  },
  modules: {},
  plugins: [vuexLocal],
})
